<template>
  <div class="choose-school-wrapper">
    <div class="ui-search-bar">
      <div class="input-box">
        <i class="icon icon-search"></i>
        <form action onsubmit="return false;" autocomplete="“off”">
          <input
            type="search"
            placeholder="请输入参评地市"
            v-model="keyWord"
            autofocus
            id="searchBox"
            ref="searchBox"
            autocomplete="off"
            @search="handleSearch"
          />
        </form>
        <i class="icon icon-close" @click="handelClear" v-show="keyWord !== ''"></i>
      </div>
      <span class="btn btn-cancel" :disabled="keyWord === ''" @click="handleSearch">搜索</span>
    </div>
    <div class="school-list">
      <div class="school-item" v-for="(item, index) in unitList" :key="`unit_${index}`" @click="handleChoose(item, index)">
        <span class="school-name">{{ item.companyName }}</span>
        <div class="icon-wrapper">
          <i class="icon-check" :class="activeIndex === index ? 'active' : ''"></i>
        </div>
      </div>
    </div>
    <NoWorksData :showNoWorksData="showNoSearchList" noDataText="暂无匹配结果" />
  </div>
</template>

<script>
import { searchUnit } from "@/server/interfaces"
import { mapGetters, mapMutations } from "vuex"
import NoWorksData from "@/components/NoWorksData"

export default {
  name: "chooseUnit",
  data() {
    return {
      keyWord: "",
      activeIndex: "",
      originUnitList: [],
      unitList: [],
      showNoSearchList: false
    }
  },
  methods: {
    ...mapMutations({
      setSelectUnitInfo: "userInfo/setSelectUnitInfo"
    }),
    handelClear() {
      this.keyWord = ""
      this.handleSearch()
    },
    async handleGetUnitList() {
      const params = {
        params: {
          keyword: this.keyWord,
          activityId: this.activityId
        }
      }
      const unitList = await searchUnit(params)
      this.showNoSearchList = unitList.length < 1
      const activeIndex = unitList.findIndex(unitItem => {
        return unitItem.companyName === this.selectUnitInfo.companyName || unitItem.companyName === this.userInfo.company.companyName
      })
      this.activeIndex = activeIndex > -1 ? activeIndex : ""
      this.originUnitList = unitList
      this.unitList = this.originUnitList
    },
    handleChoose(item, index) {
      this.setSelectUnitInfo(item)
      this.activeIndex = index
      // this.$router.go(-1)
      this.$emit("close")
    },
    handleSearch() {
      this.unitList =
        this.keyWord === "" ? this.originUnitList : this.originUnitList.filter(unitItem => unitItem.companyName.indexOf(this.keyWord) > -1)
      const activeIndex = this.unitList.findIndex(unitItem => {
        return unitItem.companyName === this.selectUnitInfo.companyName || unitItem.companyName === this.userInfo.company.companyName
      })
      this.activeIndex = activeIndex > -1 ? activeIndex : ""
    }
  },
  components: {
    NoWorksData
  },
  computed: {
    ...mapGetters({
      selectUnitInfo: "userInfo/selectUnitInfo",
      activityId: "activityInfo/activityId",
      userInfo: "userInfo/userInfo"
    })
  },
  created() {
    this.handleGetUnitList()
  }
}
</script>

<style lang="scss" scoped>
.choose-school-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999999;
  background: #ffffff;
  .ui-search-bar {
    flex: none;
    position: relative;
    display: flex;
    align-items: center;
    padding: 0.2rem 0.3rem 0;
    width: 100%;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.3rem 0.3rem 0 0;
    transition: all 100ms ease-in-out;
    overflow: hidden;
    &.top {
      border-radius: 0;
    }
    .input-box {
      background: #eeeeee;
      border-radius: 0.35rem;
      padding: 0 0.2rem;
      display: flex;
      align-items: center;
      position: relative;
      height: 0.64rem;
      flex: 1;
      .icon-search {
        background: url("../../assets/images/searchbar_icon_grey.png") no-repeat center;
        background-size: 100%;
        height: 0.36rem;
        width: 0.36rem;
        margin-right: 0.1rem;
        flex: none;
      }
      form {
        height: 100%;
        flex: 1;
        display: flex;
      }
      input {
        height: 100%;
        border: none;
        outline: none;
        background: transparent;
        padding: 0.18rem 0;
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        color: #333333;
        line-height: 0.28rem;
        flex: 1;
        line-height: 0.44rem;
      }
      .icon-close {
        background: url("../../assets/images/searchbar_icon_close.png") no-repeat center;
        background-size: 0.3rem 0.3rem;
        height: 100%;
        width: 0.64rem;
        position: absolute;
        top: 0;
        right: 0;
        &:active {
          opacity: 0.7;
        }
      }
    }
    .btn-cancel {
      margin-left: 0.3rem;
      font-family: PingFangSC-Regular;
      font-size: 0.32rem;
      color: #333333;
      letter-spacing: 0;
      text-align: center;
      flex: none;
      color: #4ca1fe;
      &:active {
        opacity: 0.7;
      }
      &[disabled] {
        color: #999999;
        &:active {
          opacity: 1;
        }
      }
    }
  }
  .school-list {
    overflow: auto;
    padding-left: 0.3rem;
    .school-item {
      display: flex;
      align-items: center;
      font-family: PingFangSC-Regular;
      font-size: 0.32rem;
      color: #333333;
      letter-spacing: 0;
      line-height: 1.12rem;
      border-bottom: 1px solid #e3e3e3;
      .school-name {
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .icon-wrapper {
        width: 0.32rem;
        height: 0.24rem;
        margin: 0 0.5rem 0 0.3rem;
        .icon-check {
          display: block;
          width: 100%;
          height: 100%;
          background: url("../../assets/images/icon_tick.png") no-repeat center;
          background-size: 100%;
          transition: all 0.3s ease-in-out;
          transform-origin: 50% 50%;
          transform: scale(0.5);
          opacity: 0;
          &.active {
            opacity: 1;
            transform: scale(1);
          }
        }
      }
    }
  }
}
</style>
